import {
  EventName,
  type UserSignedUpProperties,
  type UserLoggedInProperties,
  type OrganizationInterestApplicationSubmittedProperties,
  type OrganizationApprovedProperties,
  type OrganizationRejectedProperties,
  type OrganizationInReviewProperties,
  type PartnerSignUpCompleteProperties
} from '../types/events';

export function trackUserSignedUp(properties: UserSignedUpProperties) {
  return {
    event: EventName.UserSignedUp,
    properties
  };
}

export function trackUserLoggedIn(properties: UserLoggedInProperties) {
  return {
    event: EventName.UserLoggedIn,
    properties
  };
}

export function trackOrganizationInterestApplicationSubmitted(
  properties: OrganizationInterestApplicationSubmittedProperties
) {
  return {
    event: EventName.OrganizationInterestApplicationSubmitted,
    properties
  };
}

export function trackPartnerSignUpComplete(
  properties: PartnerSignUpCompleteProperties
) {
  return {
    event: EventName.PartnerSignUpComplete,
    properties
  };
}

export function trackOrganizationApproved(
  properties: OrganizationApprovedProperties
) {
  return {
    event: EventName.OrganizationApproved,
    properties
  };
}

export function trackOrganizationRejected(
  properties: OrganizationRejectedProperties
) {
  return {
    event: EventName.OrganizationRejected,
    properties
  };
}

export function trackOrganizationInReview(
  properties: OrganizationInReviewProperties
) {
  return {
    event: EventName.OrganizationInReview,
    properties
  };
}
